<template>
  <div class="view__container">
    <DeterminationFileRow
      v-for="file in determinationDocuments"
      :key="file.documentId"
      :can-remove-document="canRemoveDocument"
      :can-replace="canReplace"
      :created-by="file.createdBy"
      :created-date="file.createdDate"
      :document-file-name="file.documentFileName"
      :document-id="file.determinationDocumentId"
      :document-name="file.documentName"
      :evaluator-name="file.evaluatorName"
      :is-provisional-remedy-area="isProvisionalRemedyArea"
      @download="downloadFile(file.documentId)"
      @remove="onRemoveDocumentHandler(file)"
      @replace="upsertFile"
    />

    <DeterminationFileUpload
      v-if="isShowingUploadFile"
      :is-provisional-remedy-area="isProvisionalRemedyArea"
      @cancel="isShowingUploadFile = false"
      @upload="upsertFile"
    />

    <div v-else>
      <div
        v-if="determinationDocuments.length > 0"
        class="d-flex justify-content-end"
      >
        <action-button
          i="fas fa-file-plus"
          variant="success"
          @click="isShowingUploadFile = true"
        >
          Añadir
        </action-button>
      </div>
      <div v-else class="upload-file-button__container">
        <action-button
          class="upload-file-button"
          class-icon="green-icon"
          i="fas fa-file-plus"
          @click="isShowingUploadFile = true"
        >
          Presione aquí para anejar documento
        </action-button>
      </div>
    </div>
  </div>
</template>
<script>
import { serialize as objectToFormData } from 'object-to-formdata';
import _generalService from '@/modules/app/api';
import {
  getProposalDeterminationDocuments,
  uploadDeterminationDocument,
  removeProposalRequestDeterminationDocument as _removeProposalRequestDeterminationDocument,
} from '@/modules/proposalProcess/api.js';
import alert from '@/mixins/alert.mixin';

import ActionButton from 'ActionButton';
import DeterminationFileRow from './DeterminationFileRow.vue';
import DeterminationFileUpload from './DeterminationFileUpload.vue';

const PERMISSION_REPLACEMENT =
  'provider.proposal.determination.documents.replacement';

export default {
  name: 'ProposalDeterminationDocuments',
  components: {
    ActionButton,
    DeterminationFileRow,
    DeterminationFileUpload,
  },
  mixins: [alert],
  props: {
    isProvisionalRemedyArea: Boolean,
  },
  data: () => ({
    isShowingUploadFile: false,
    determinationDocuments: [],
  }),
  computed: {
    canReplace() {
      return this.userHasPermissions(PERMISSION_REPLACEMENT);
    },
    proposalRequestId() {
      return this.$route.params.id;
    },
    canRemoveDocument() {
      return this.userHasPermissions(
        'provider.proposal.determination.removedocument'
      );
    },
  },
  async mounted() {
    await this.fetchDocuments();
  },
  methods: {
    downloadFile(fileId) {
      _generalService.downloadDocumentByAttachmentId(fileId);
    },
    async upsertFile(data) {
      const formData = {
        proposalRequestId: this.proposalRequestId,
        determinationDocumentId: data.id,
        documentName: data.name,
        evaluatorName: data.evaluatorName,
        file: data.file,
      };

      const payload = objectToFormData(formData, { indices: true });
      const isReplacement = !!data.id;
      let message = 'El documento ha sido reemplazado exitosamente.';

      if (!isReplacement) {
        message = 'El documento ha sido añadido exitosamente.';
        this.isShowingUploadFile = false;
      }

      await uploadDeterminationDocument(payload);
      await this.fetchDocuments();
      this.ShowToast('', message, 'success');
    },
    async fetchDocuments() {
      const { data } = await getProposalDeterminationDocuments(
        this.proposalRequestId
      );
      this.determinationDocuments = [...data];
    },
    async onRemoveDocumentHandler({ proposalRequestId, documentId }) {
      if (proposalRequestId && documentId) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro(a) que desea eliminar el documento seleccionado?',
          'Sí',
          'No'
        );
        if (!answer) return;

        const { data } = await _removeProposalRequestDeterminationDocument(
          proposalRequestId,
          documentId
        ).catch((error) => {
          this.ShowToast('Alerta', `${error.response.data.message}.`, 'error');
          return { data: false };
        });

        if (data) {
          this.ShowToast(
            'Confirmación',
            'El documento ha sido eliminado exitosamente.',
            'success'
          );
          await this.fetchDocuments();
        }
      }
    },
  },
};
</script>
<style>
.view__container {
  margin-top: 48px;
  margin-bottom: 80px;
}
.upload-file-button__container {
  background-color: #f7f7f7;
  border-radius: 2px;
  padding: 30px 0;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}
.upload-file-button {
  border: 1px solid #e2e2e2 !important;
  padding: 5px 40px !important;
  font-size: 16px;
}
.green-icon {
  color: #2db782;
}
</style>
